import React, { useState, useEffect, Fragment } from 'react';
import { useCart } from '../../core/context/CartContext';
import { useAuthClient } from '../../core/context/AuthClientContext';

const CartSidebar = ({ cartItems, totalPrice, closeCart, openOrderForm }) => {
  const { addToCart, removeFromCart, decreaseQuantity } = useCart();
  const { user } = useAuthClient();
  const [locationName, setLocationName] = useState('Localisation inconnue');

  useEffect(() => {
    const fetchLocation = async (lat, lon) => {
      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`
        );
        const data = await response.json();
        const city =
          data.address.city ||
          data.address.town ||
          data.address.village ||
          data.address.county ||
          data.address.state ||
          data.address.country;
        setLocationName(city || 'Localisation inconnue');
      } catch {
        setLocationName('Localisation inconnue');
      }
    };

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => fetchLocation(pos.coords.latitude, pos.coords.longitude),
        () => setLocationName('Localisation refusée')
      );
    } else {
      setLocationName('Géolocalisation non supportée');
    }
  }, []);

  const handleAddMore = () => {
    closeCart();
    const menuSection = document.getElementById('menu');
    if (menuSection) {
      menuSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleCheckout = () => {
    if (!user) {
      openOrderForm(); // Délègue à AppWrapper : il ouvrira Login si besoin
      return;
    }
    closeCart();
    openOrderForm && openOrderForm();
  };

  return (
    <Fragment>
      <aside
        className="cart-sidebar border-start p-3 bg-white shadow"
        style={{
          width: '350px',
          maxHeight: '100vh',
          overflowY: 'auto',
          zIndex: 1200,
          position: 'relative'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={closeCart}
          aria-label="Fermer le panier"
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            background: 'none',
            border: 'none',
            fontSize: '1.5rem',
            cursor: 'pointer',
            color: '#333'
          }}
        >
          ×
        </button>

        <div className="mb-3 d-flex align-items-center gap-2">
          <i className="bi bi-geo-alt-fill"></i>
          <strong>{locationName}</strong>
        </div>

        <h2>Votre panier</h2>

        {Object.keys(cartItems).length === 0 ? (
          <p>Votre panier est vide</p>
        ) : (
          <>
            <ul className="list-group mb-3">
              {Object.values(cartItems).map(({ item, quantity }) => (
                <li
                  key={item._id}
                  className="list-group-item d-flex justify-content-between align-items-center"
                >
                  <div style={{ flex: 1 }}>
                    <h5 className="mb-1">{item.name}</h5>
                    <small className="text-muted">{item.description}</small>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <button
                      className="btn btn-sm btn-outline-secondary"
                      onClick={() => decreaseQuantity(item._id)}
                      aria-label={`Réduire la quantité de ${item.name}`}
                    >
                      -
                    </button>
                    <span>{quantity}</span>
                    <button
                      className="btn btn-sm btn-outline-primary"
                      onClick={() => addToCart(item)}
                      aria-label={`Augmenter la quantité de ${item.name}`}
                    >
                      +
                    </button>
                    <button
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => removeFromCart(item._id)}
                      aria-label={`Supprimer ${item.name} du panier`}
                    >
                      ×
                    </button>
                  </div>
                  <div className="ms-3 fw-bold">
                    {(item.price * quantity).toFixed(2)} €
                  </div>
                </li>
              ))}
            </ul>

            <div className="d-flex justify-content-between align-items-center border-top pt-3 mb-3">
              <strong>Total :</strong>
              <span className="fs-5 fw-bold">{totalPrice.toFixed(2)} €</span>
            </div>

            <div className="d-flex flex-column gap-2">
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={handleAddMore}
              >
                Rajouter un produit
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleCheckout}
              >
                Valider la commande
              </button>
            </div>
          </>
        )}
      </aside>
    </Fragment>
  );
};

export default CartSidebar;
